import { createDeepEqualSelector } from 'js/utils/redux.util';
import { useSelector as useReduxSelector, type TypedUseSelectorHook } from 'react-redux';

import { TRootState } from 'js/store/types';

export const useSelector: TypedUseSelectorHook<TRootState> = (selector, equalityFn) => {
    const deepSelector = createDeepEqualSelector([selector], (data) => data);

    return useReduxSelector(deepSelector, equalityFn);
};
